<template>
	<v-dialog
		v-model="ui.dialog"
		persistent
		:width="$vuetify.breakpoint.smAndDown ? '100%' : '800px'"
	>
		<v-card :class="[$vuetify.breakpoint.smAndDown ? 'pa-2' : 'pa-4']">
			<v-card-title
				:class="[
					'd-flex',
					ui.success ? 'justify-center' : 'justify-start',
				]"
			>
				<template v-if="ui.success">
					<div class="d-flex flex-column justify-center align-center">
						<v-icon class="success--text ml-1 display-2">
							mdi-checkbox-marked-circle-outline
						</v-icon>
						<h4>
							¡Orden de compra enviada!
						</h4>
					</div>
				</template>

				<template v-else>
					Enviar orden de compra
				</template>
			</v-card-title>
			<v-card-text>
				<template v-if="ui.success">
					<v-row>
						<v-col
							cols="12"
							class="d-flex flex-column align-center justify-center text-center black--text"
						>
							La orden de compra fue enviada correctamente.
							<br />
							Te notificaremos cuando nuestra área de ventas lo
							reciba.
						</v-col>
					</v-row>
				</template>

				<template v-else>
					<v-row>
						<v-col cols="12">
							<v-stepper
								v-model="ui.step"
								vertical
								class="elevation-0 pb-0"
							>
								<v-stepper-step
									:complete="ui.step > 1"
									step="1"
								>
									Método de envío
								</v-stepper-step>

								<v-stepper-content step="1">
									<v-card>
										<v-card-text class="pt-0">
											<v-row>
												<v-col cols="12" class="pb-0">
													<h3>
														Puedes utilizar un
														método de envío para la
														entrega de tus
														productos.
													</h3>
												</v-col>

												<v-col cols="12" class="pb-0">
													<v-switch
														v-model="
															ui.shipping_method
														"
														inset
														label="Utilizar un metodo de envío"
													></v-switch>
												</v-col>

												<v-col
													v-if="ui.shipping_method"
													cols="12"
													class="pb-0"
												>
													<v-overflow-btn
														flat
														darck
														outlined
														editable
														clearable
														autocomplete="off"
														label="Metodo de envío"
														background-color="#fff"
														:dense="
															$vuetify.breakpoint
																.mdAndUp
														"
														:items="
															this.shipping_methods.map(
																(item) => {
																	return {
																		text:
																			item.name,
																		value:
																			item.id,
																	};
																}
															)
														"
														:disabled="
															$store.state.ui
																.getingShippingMethods
														"
														:loading="
															$store.state.ui
																.getingShippingMethods
														"
														v-model="
															layout.shipping_method_id
														"
													></v-overflow-btn>
												</v-col>
											</v-row>
										</v-card-text>
										<v-card-actions
											class="d-flex justify-space-between"
										>
											<v-btn
												text
												class="mr-2"
												@click="ui.dialog = false"
												:disabled="ui.storing"
												:large="
													$vuetify.breakpoint
														.smAndDown
												"
												:block="
													$vuetify.breakpoint
														.smAndDown
												"
											>
												Cancelar
											</v-btn>

											<v-btn
												color="primary"
												@click="ui.step = 2"
											>
												continuar
											</v-btn>
										</v-card-actions>
									</v-card>
								</v-stepper-content>

								<v-stepper-step
									:complete="ui.step > 2"
									step="2"
								>
									Datos complementarios
								</v-stepper-step>

								<v-stepper-content step="2">
									<v-card>
										<v-card-text class="pt-0">
											<v-form
												ref="others"
												v-model="ui.forms.others"
												lazy-validation
												@submit.prevent=""
											>
												<v-row>
													<v-col cols="12">
														<h3>
															Puedes añadir
															información
															complementaria en
															caso de ser
															necesario.
														</h3>
													</v-col>

													<v-col
														cols="12"
														class="pb-0"
													>
														<v-textarea
															clearable
															label="Nota"
															:counter="
																ui.maxLengthNote
															"
															:rules="[
																v.max(
																	'text',
																	ui.maxLengthNote,
																	layout.note
																),
															]"
															v-model="
																layout.note
															"
															outlined
														></v-textarea>
													</v-col>
												</v-row>
											</v-form>
										</v-card-text>
										<v-card-actions
											class="d-flex justify-space-between"
										>
											<v-btn
												text
												@click="ui.dialog = false"
												:disabled="ui.storing"
												:large="
													$vuetify.breakpoint
														.smAndDown
												"
												:block="
													$vuetify.breakpoint
														.smAndDown
												"
											>
												Cancelar
											</v-btn>
											<div>
												<v-btn
													color="primary"
													text
													@click="ui.step = 1"
												>
													regresar
												</v-btn>

												<v-btn
													color="primary"
													@click="store()"
													:loading="ui.storing"
													:large="
														$vuetify.breakpoint
															.smAndDown
													"
													:block="
														$vuetify.breakpoint
															.smAndDown
													"
													:disabled="!ui.forms.others"
													:class="[
														{
															'mb-3':
																$vuetify
																	.breakpoint
																	.smAndDown,
														},
													]"
												>
													Enviar
												</v-btn>
											</div>
										</v-card-actions>
									</v-card>
								</v-stepper-content>
							</v-stepper>
						</v-col>
					</v-row>
				</template>
			</v-card-text>

			<v-card-actions
				v-if="ui.success"
				:class="[
					'd-flex',
					'justify-end',
					{ 'flex-column-reverse': $vuetify.breakpoint.smAndDown },
				]"
			>
				<v-btn
					text
					color="primary"
					@click="$router.push({ name: 'PurchasesIndex' })"
					:large="$vuetify.breakpoint.smAndDown"
					:block="$vuetify.breakpoint.smAndDown"
				>
					ver mis pedidos
				</v-btn>

				<v-btn
					color="primary"
					:large="$vuetify.breakpoint.smAndDown"
					:block="$vuetify.breakpoint.smAndDown"
					@click="$router.push({ name: 'StoreIndex' })"
					:class="[{ 'mb-3': $vuetify.breakpoint.smAndDown }]"
				>
					seguir comprando
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import { EventBus } from "@/main";
import { V } from "@/main";
import axios from "axios";

export default {
	name: "",

	data() {
		return {
			v: V,

			acount: {},

			layout: {
				note: null,
				shipping_method_id: null,
			},

			ui: {
				forms: {
					others: true,
				},
				step: 1,
				storing: false,
				dialog: false,
				success: false,
				maxLengthNote: 250,
				shipping_method: false,
			},
		};
	},

	created() {
		this.$store.dispatch("getShippingMethods");

		this.account = this.getAcount;

		EventBus.$on("PurchaceOrderCreate", () => {
			if (this.$store.state.authenticated) {
				this.ui.dialog = true;
			} else {
				EventBus.$emit("LoginRequest");
			}
		});
	},

	methods: {
		async store() {
			if (!this.$refs.others.validate()) {
				return false;
			}

			try {
				this.ui.storing = true;

				let payload = {
					...this.layout,
					user_id: this.account.user.id,
					customer_id: this.account.user.customer.id,
					articles: this.getArticles.map((article) => {
						return {
							id: article.id,
							amount: article.amount,
							discount: article.discount,
						};
					}),
				};

				let resp = await axios.post(
					`${process.env.VUE_APP_API_SERVER}/auth/customer/purchaceorder`,
					payload,
					{
						headers: {
							Authorization: `Bearer ${this.getToken}`,
						},
					}
				);

				this.ui.success = true;
				this.$store.commit("cart/CLEAR");
			} catch (error) {
				EventBus.$emit("Error", {
					error: error,
					errorsShow: true,
				});
			} finally {
				this.ui.storing = false;
			}
		},
	},

	computed: {
		...mapState(["shipping_methods"]),

		...mapGetters({
			getToken: "getToken",
			getAcount: "getAcount",
			getArticles: "cart/getArticles",
		}),
	},
};
</script>

<style lang="css" scoped></style>
